export class DrillDownInfo {
    constructor(
        public canDrillDown = false,
        public isDrillDowned = false,
        public drillDownToId = "",
        public drillDownToName = ""
    ) { }
}
